import type {
    ComponentStageData,
    InnerElementStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {fontHeuristics, scaleInnerElementFontSizes} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'
import {getStylePointer} from '../../conversionDal/utils/pointer'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const scaleFontSize = (componentStageData: ComponentStageData) => {
        const heuristicToApply = fontHeuristics.find(({predicate}) => predicate(componentStageData))!

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: heuristicToApply.heuristicCode ? [heuristicToApply.heuristicCode] : []
        }
    }

    const scaleInnerElementFontSize = (innerElementStageData: InnerElementStageData) => {
        const {innerElementPointer, initialSnapshot} = innerElementStageData

        if (!initialSnapshot.getValue(getStylePointer(innerElementPointer))) {
            return
        }

        scaleInnerElementFontSizes(innerElementStageData)

        return {
            appliedHeuristics: ['RESCALE INNER ELEMENT FONT SIZES']
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(scaleFontSize))
        registry.registerInnerElementHandler(stages.TRANSFORM_STYLE, scaleInnerElementFontSize)
    }

    const name = 'textScale'
    return {register, name, dependencies: []}
}
